export default __webpack_public_path__ + "static/media/alert-circle.8d74f911.svg";